module.exports = __webpack_public_path__ + "static/media/advanced_debug.355fcf90.jpg";